// Billing (de-billing-service) алдааны кодыг хүн ойлгомжтой монгол мессеж рүү буулгана.
// Backend ихэнх тохиолдолд алдааны мессеж дотроо код (ж: "BILLING_POLICY_DRAFT_EXISTS")
// эсвэл "error.billing.*" түлхүүр буцаадаг тул UI дээр шууд харуулахад ойлгомжгүй.
const BILLING_ERROR_MESSAGES: Record<string, string> = {
  BILLING_POLICY_DRAFT_EXISTS      : "Энэ хүрээнд хадгалсан ноорог (DRAFT) аль хэдийн байна. Шинээр үүсгэхийн оронд хуучин ноорогоо засна уу.",
  BILLING_POLICY_NEEDS_NAME        : "Нэртэй бодлогод нэр заавал шаардлагатай.",
  BILLING_NAMED_POLICY_NAME_DUPLICATE: "Энэ нэртэй бодлого аль хэдийн бүртгэгдсэн байна. Өөр нэр сонгоно уу.",
  BILLING_DEFAULT_POLICY_EXISTS    : "Үндсэн (DEFAULT) бодлого аль хэдийн байна. Нэг л идэвхтэй үндсэн бодлого байж болно.",
  BILLING_POLICY_NOT_FOUND         : "Бодлого олдсонгүй.",
  BILLING_POLICY_NOT_DRAFT         : "Зөвхөн ноорог (DRAFT) төлөвт байгаа бодлогыг засах боломжтой.",
  BILLING_POLICY_INVALID_STATUS    : "Бодлогын одоогийн төлөв энэ үйлдэлд тохирохгүй байна.",
  BILLING_POLICY_ALREADY_ACTIVE    : "Энэ хүрээнд идэвхтэй бодлого аль хэдийн байна.",
  BILLING_POLICY_STALE_ROWVERSION  : "Энэ бодлогыг өөр хэрэглэгч шинэчилсэн байна. Дахин ачаалаад үргэлжлүүлнэ үү.",
  BILLING_FEE_VALUE_INVALID        : "Шимтгэлийн утга буруу байна. Хувь эсвэл дүнгээ шалгана уу.",
  BILLING_TIER_CONFIG_INVALID      : "Шатлалын тохиргоо буруу байна. Шатлалуудаа шалгана уу.",
  BILLING_TIER_COUNT_EXCEEDED      : "Шатлал хамгийн ихдээ 10 байж болно.",
  BILLING_CONTRACT_TENANT_NOT_FOUND: "Тухайн харилцагчийн billing бүртгэл олдсонгүй.",
};

/**
 * HttpHandler-аас шидсэн алдааг (.code / .message бүхий объект) хүн ойлгомжтой
 * монгол мессеж болгож буулгана. Тохирох код байхгүй бол backend-ийн мессеж,
 * түүнийг ч уншигдахааргүй (код/түлхүүр) бол ерөнхий мессеж буцаана.
 */
export function resolveBillingError(e: unknown): string {
  const err = e as { code?: string; message?: string } | undefined;
  const code = err?.code;
  if (code && BILLING_ERROR_MESSAGES[code]) return BILLING_ERROR_MESSAGES[code];

  const message = err?.message;
  // Backend нь ихэвчлэн мессеж дотроо кодоо (ALL_CAPS) эсвэл "error.*" түлхүүр
  // дамжуулдаг — эдгээрийг хэрэглэгчид харуулахгүй.
  const looksLikeCode = typeof message === "string" && /^[A-Z0-9_]+$|^error\./.test(message);
  if (message && !looksLikeCode) return message;

  return "Үйлдэл амжилтгүй боллоо. Дахин оролдоно уу.";
}
